module.exports = __webpack_public_path__ + "img/html.8541f65f.svg";